import React, { useState, useEffect } from "react";
import ShortText from "../../utils/ShortText";
import InfoModal from "../Modal/InfoModal";
import { useTranslation } from "react-i18next";
import TwoLineClampWithReadMore from "../Read-More/TwoLineClampWithReadMore";
import TruncatedDescription from "../Read-More/TruncatedDescription";
import i18next from "i18next";
import { useSelector } from "react-redux";
const StoreDescription = ({ refrencePage, store, }: { refrencePage?: any, store?: any }) => {

    const [isInfo, setIsInfo] = useState(false);

  // console.log('storestore', store)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [lang, setLang] = useState(i18next?.language);
  const { translations } = useSelector((state: any) => state?.languageData);
    const { t } = useTranslation()

    let isOrder = (refrencePage == 'CurrentOrder' || refrencePage == 'OrderDetail')
    // console.log('refrencePage', refrencePage) //VariationModal
    // Determine max length based on screen width

    return <>
        {store?.description && (
            <p className="cardDesciption">
                <span className="line-2">
                    {/* @@ description read more */}
                    {store?.description && <>
                        <TruncatedDescription description={store?.description} onClick={(e: any) => {
                            e.stopPropagation();
                            setIsInfo(true);
                        }} />
                    </>}
                </span>
            </p>
        )}
        {((isOrder) && store?.rating > 0) ? <>
            <div className="flex  textbase font-normal gap-1 items-center mb-2">
                <i className="fa fa-star text-yellow-500"></i>
                <p>
                    {store?.rating?.toFixed(1)}{" "}
                    <span className="text-[#828282]">
                        ({store?.rating_count || 0} {t("Review.ratings")})
                    </span>
                </p>
            </div>
        </> : null}

     
        <InfoModal
          item={{ name: store?.store_name, ...store }}
          isInfo={isInfo}
          setIsInfo={setIsInfo}
          lang={lang}
          translations={translations}
        />
    </>
}


export default StoreDescription;
